import { apiFetch } from "./client.js";

export interface PostTransferBody {
  fromKidId: string;
  toKidId: string;
  amountCents: number;
  note: string;
}

export interface PostTransferResponse {
  ok: true;
}

export async function postTransfer(body: PostTransferBody): Promise<PostTransferResponse> {
  return apiFetch<PostTransferResponse>(
    "/api/transfers",
    { method: "POST", body: JSON.stringify(body) },
    true,
  );
}
